import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const Like = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17 4C13.8 4 12 6.66667 12 8C12 6.66667 10.2 4 7 4C3.8 4 3 6.66667 3 8C3 15 12 20 12 20C12 20 21 15 21 8C21 6.66667 20.2 4 17 4Z"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Like;
